module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<span class="lock-icon"></span>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/integrations/customJs/lockIcon/CustomJsLockIconView.tpl
// module id = 3069
// module chunks = 0